import NIMSDKIM from 'src/utils/nim/index';
import validate from 'src/utils/validate';

export const timCustomData = (jsonStr = '') => {
  try {
    return JSON.parse(jsonStr);
  } catch (error) {
    return {};
  }
};
//针对支付宝 上传图片 进行自定义消息推送
export const aliPaycustomSendImageMessageData = (link) => {
  const url = window.location.origin + link;
  return JSON.stringify({
    "customEvent": "CMD_014",
    contentsType:"IMAGE",
    resourceType:"8",
    "customExts": {
      type: 'IMAGE',
      fileId: url,
      image: url,
      url
    }
  });
}
const customDataMessage = (message, imType = '') => {
  let { cloudCustomData = '', content = '', payload: { groupJoinType = '', extension = '', data = '' } = {} } = message;
  const { from: customFrom = '', customEvent = '', customExts = {} } = timCustomData(cloudCustomData || content || '{}');
  let from = message.from;
  if (data == 'group_create' || groupJoinType == 1 || groupJoinType == 2 || customFrom === 'system' || ['CMD_010'].includes(customEvent)) {
    from = 'system';
  }
  return {
    ...message,
    from,
    contentsType: 'CUSTOM',
    customEvent,
    customExts: {
      content: extension,
      date: '',
      ...customExts,
    },
    //tim 返回的时间 为秒，其他为豪秒
    time: imType == 'tim' ? message.time * 1000 : message.time,
  };
};

//转换成im接口返回的一样的数据格式
export const parseFromConversion = (message, bodyType) => {
  let { body: { msg = '', url = '' } = {}, payload: { text = '', imageInfoArray: [firstItem = {}] = [] } = {}, file: { url: nimUrl = '' } = {} } = message;
  switch (bodyType) {
    case 'txt':
    case 'text':
      return {
        ...message,
        contentsType: 'TEXT',
        data: msg || message.data || message.text,
        sourceMsg: msg || message.sourceMsg,
      };
      break;
    case 'img':
    case 'image':
      return {
        ...message,
        contentsType: 'IMAGE',
        url: url || message.url || nimUrl,
      };
      break;
    case 'file':
    case 'audio':
    case 'video':
    case 'custom':
      //九州通
      if (message.fromClientType && bodyType === 'custom') {
        // console.log('九州通', message.fromClientType)
        return customDataMessage(message);
      }
      return {
        ...message,
      };
      break;
      break;
    /*以下部分为tim sdk*/
    case 'TIMTextElem':
      return {
        ...message,
        contentsType: 'TEXT',
        data: text,
      };
      break;
    case 'TIMImageElem':
      return {
        ...message,
        contentsType: 'IMAGE',
        url: firstItem.imageUrl || firstItem.url,
      };
      break;
    // case 'TIMGroupTipElem':
    case 'TIMCustomElem':
      return customDataMessage(message, 'tim');
    default:
      return {
        ...message,
      };
  }
};

export const copy = (message, tpl) => {
  let obj = {};
  Object.keys(tpl).forEach((v) => {
    obj[v] = message[v] || tpl[v];
  });
  return obj;
};
let referralsCodeList = ['CMD_014', 'CMD_015', 'CMD_016']; //转诊过来的消息类型
export const isImageTypeMsg = (message) => {
  let { contentsType = '', customEvent = '', customExts: { type = '' } = {} } = message;
  return (contentsType == 'CUSTOM' && customEvent == 'CMD_004') || (referralsCodeList.includes(customEvent) && type == 'IMAGE') || contentsType === 'IMAGE';
};
export const parseCustomImageConversion = (message) => {
  let { customExts: { image = '', fileId = '' } = {}, payload: { imageInfoArray: [firstItem = {}] = [] } = {} } = message;
  //针对病历处理消息特殊处理
  if (isImageTypeMsg(message)) {
    let src = message.url || image || fileId || firstItem.imageUrl || firstItem.url;
    message.url = src;
    message.source = src;
    message.contentsType = 'IMAGE';
  }
  return message;
};

export const getNIMHistoryMsgList = (options = {}) => {
  return new Promise((resolve, reject) => {
    NIMSDKIM.nim.getHistoryMsgs({
      sessionId: 'p2p', //表示单聊场景(p2p)，对方账号为account。
      scene: 'p2p',
      reverse: false,
      asc: true,
      limit: 15,
      ...options,
      done: (error, obj) => {
        // console.log('obj', obj);
        if (!error) {
          console.log(obj.msgs);
          let { msgs = [] } = obj;
          const [firstTime = {}] = msgs;
          resolve({
            list: msgs,
            isMore: msgs.length == 15,
            lastMessageTime: firstTime.time,
          });
        } else {
          reject({});
        }
      },
    });
  });
};

//发送文本消息
export const sendNIMTxtMessage = (options = {}) => {
  return new Promise((resolve, reject) => {
    return NIMSDKIM.nim.sendText({
      scene: 'p2p',
      type: 'text',
      ...options,
      done: (error, msg) => {
        if (!error) {
          console.log(msg);
          resolve({
            code: 0,
            data: msg,
          });
        } else {
          reject({
            code: -10,
            data: {},
          });
        }
      },
    });
  });
};

//发送图片消息
export const sendNIMImageMessage = (options) => {
  return new Promise((resolve, reject) => {
    let baseOpts = {
      scene: 'p2p',
      type: 'image',
      content: '',
      ...(options || {}),
      done: (error, msg) => {
        if (!error) {
          console.log(JSON.stringify(msg),"sendCustomMsg");
          resolve({
            code: 0,
            data: msg,
          });
        } else {
          reject({
            code: -10,
            data: {},
          });
        }
      },
    }
    //支付宝 部分手机不兼容，改为自定义消息，图片会用原生组件先上传完
    if (validate.isAlipayApplet()) {
      let { fileInput = {} } = options || {};
      baseOpts.content = aliPaycustomSendImageMessageData(fileInput.link);
      NIMSDKIM.nim.sendCustomMsg(baseOpts);
      return
    }
    NIMSDKIM.nim.sendFile(baseOpts);
  });
};
